module.exports = __webpack_public_path__ + "static/Abacus Budget Cockpit 2-7955bf7f2aec2fd8b875bb1ca44ac796.png";